import { createRoot } from "react-dom/client";
import { GlobalErrorBoundary } from "./components/GlobalErrorBoundary";
import App from "./App.tsx";
import "./index.css";

// Signal that module loaded successfully
(window as unknown as { __appBootStarted: boolean }).__appBootStarted = true;
console.log('[BOOT] main.tsx module loaded');

createRoot(document.getElementById("root")!).render(
  <GlobalErrorBoundary>
    <App />
  </GlobalErrorBoundary>
);
